export class PhotoForList {
  _id?: string;
  image: string = '';
  alt: string = '';
  position: number = 0;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/photo-for-list.model.ts